module.exports = __webpack_public_path__ + "img/imgYLSYB(8).a9c4eb30.png";